/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const newFormImages = () => {
  // const removeItems = document.querySelectorAll('.js-remove-elem');
  // removeItems.forEach(element => {
  //   element.addEventListener('click', e => {
  //     const parent = e.target.parentElement.parentElement.parentElement;
  //     parent.find('.js-remove-elem--form').classList.remove('u-hidden');
  //     parent.find('.js-remove-elem--item').classList.add('u-hidden');
  //   });
  // });
};

export default newFormImages;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/newFormImages.js